var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 32.5565C10.751 32.5565 5.49753 29.5545 2.62061 24.5512C-0.256309 19.6104 -0.256309 13.5438 2.62061 8.5405C5.49753 3.5997 10.751 0.535156 16.5049 0.535156C22.1962 0.535156 27.4497 3.5997 30.3266 8.5405C33.2035 13.5438 33.2035 19.6104 30.3266 24.5512C27.4497 29.5545 22.1962 32.5565 16.5049 32.5565ZM24.5728 12.6057L22.4463 10.4793L14.5035 18.4221L10.5634 14.482L8.43699 16.6084L14.5035 22.6749L24.5728 12.6057Z",
    fill: "#209F7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGreenCheck);
export default __webpack_public_path__ + "static/media/circle_green_check.b88c4c4fcbd3307c6fa2dad21b57f127.svg";
export { ForwardRef as ReactComponent };